// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 22H2V2H11V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 22H13V2H22V22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-column-layout-filled')
export default class ColumnLayoutFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'column-layout-filled',
    }
  }
}
